import { Form, type FormikConfig, FormikProvider, type FormikValues, useFormik } from 'formik';
import * as Yup from 'yup';

type Props<T extends FormikValues> = {
  children: React.ReactNode;
  initialValues: T;
  onSubmit: FormikConfig<T>['onSubmit'];
  validationSchema?: Yup.ObjectSchema<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  validate?: (values: T) => void | object | Promise<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  className?: string;
};
export const FormProvider = <T extends FormikValues>({
  children,
  initialValues,
  onSubmit,
  validationSchema,
  validate,
  className,
}: Props<T>) => {
  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    validate,
  });

  return (
    <FormikProvider value={formik}>
      <Form className={className}>{children}</Form>
    </FormikProvider>
  );
};
